import {HttpService} from "../http/HttpService";
import {Entry, ListEntriesResponse, ListTransactionsRequest, ListTransactionsResponse} from "../http/protocol";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";


export class TransactionService extends AbstractAdminEntityService<Entry, ListEntriesResponse> {
    constructor(http: HttpService) {
        super("/wallet/transactions", http);
    }
}